<template>
  <dv-full-screen-container>
<el-container class="home_container">
  <!--侧边-->
      <el-aside :width="isCollspase?'64px':'220px'">
        <div class="logo_img">
          <img :src="imgUrl"/>
        </div>
        <el-menu unique-opened background-color="#FFFFFF" text-color="black" :default-active="this.$router.history.current.path"  class="el-menu-vertical-demo" :collapse='isCollspase' :collapse-transition='false' router>
              <el-menu-item :index="'/homepage'" key="1">
                <img :src="iconArray[1]" style="width: 12px;height: 12px;margin-right: 5px;">
                <span slot="title">&nbsp;&nbsp;主页&nbsp;&nbsp;</span>
              </el-menu-item>

              <el-submenu :index="item.id" v-for="item in listMenu" :key="item.id">
                <template slot="title">
                  <img :src="iconArray[item.id]" style="width: 16px;height: 16px;margin-right: 5px;">
                  <span> {{item.name}}</span>
                </template>

                <el-menu-item :index="'/'+subitem.path"  v-for="subitem in item.chilidrens" :key="subitem.id" style="margin-left: 15px;">
                   <template slot="title">
                    <span> {{subitem.name}}</span>
                  </template>
                </el-menu-item>
              </el-submenu>
        </el-menu>
      </el-aside>

  <el-container>
      <!--头部-->
      <el-header style="background: linear-gradient(to right, #fff, #DFFFFA,#fff,#DFFFFA);">
        <span></span>
        <!-- <el-button type="primary" :icon='isCollspase?"el-icon-s-unfold":"el-icon-s-fold"' style="float:left;background-color:#919497;border-color:#919497;" @click="toggleCollspace"></el-button> -->
        <div class="remind">

          <!--提醒-->
          <!-- <div style="margin-right:50px">

            <div class="remind" style="cursor:pointer" @click="Remind">
              <i class="el-icon-bell"/>
              <label style="color:red;margin-bottom:15px">●</label>
            </div>
          </div> -->

          <div v-if="User.user_type===2||User.user_type===4" style="margin-right:50px">
            <div class="remind">
              <img src="../../assets/image/daping.png" style="width: 25px;height: 25px;"/>
              <router-link style="color:#0E5FF6;font-size: 14px;margin-left: 5px;cursor:pointer;text-decoration:none" target="_blank" :to="{name:'datascreen',params:{token:tokenStr}}">数据大屏</router-link>
            </div>
          </div>

          <el-dropdown size='medium' @command='loginOut'>
            <span class="el-dropdown-link">
              <i class="el-icon-s-custom"></i>
              {{login_name}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-key" command="a" style="font-size: 13px;">修改密码</el-dropdown-item>
              <el-dropdown-item icon="el-icon-switch-button" command="b" style="font-size: 13px;">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

      </el-header>

      <!--主体-->
      <el-main>
        <el-card style="margin-bottom: 15px;">
          <el-tabs v-model="activName" type="card" closable :addable="false" @tab-click="tabpanelChaned" @tab-remove="removeTab">
            <el-tab-pane
              :key="item.name"
              v-for="item in getCurrentRoutesCount"
              :label="item.title"
              :name="item.name"
            >
            </el-tab-pane>
          </el-tabs>
        </el-card>

        

        <router-view></router-view>
      </el-main>
  </el-container>

  <el-dialog v-if="dialogVisible" title="修改密码" :width="isCollspase?'50%':'30%'" :visible.sync="dialogVisible" >
    <PwdForm ref='childRules' :pwdForm='pwdForm'/>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="EditPwd">确 定</el-button>
    </span>
  </el-dialog>
</el-container>
</dv-full-screen-container>
</template>

<script>
import util from '../../util/util'
import PwdForm from '../../components/pwd.vue'
import { mapState } from 'vuex';

export default {
  data () {
    return {
      imgUrl:require("../../assets/image/logo.png"),
      screenWidth: 0,
      dialogVisible: false,
      defaultOpeneds: ['/homepage'],
      login_name: '',
      User:null,
      tokenStr:'',

      isCollspase: false,
       iconArray: {
        1: require("../../assets/image/zhuye.png"),
        2: require("../../assets/image/tingchechang.png"),
        3: require("../../assets/image/cheliang.png"),
        4: require("../../assets/image/shanghu.png"),
        5: require("../../assets/image/baobiao.png"),
        6: require("../../assets/image/shezhi.png"),
        7: require("../../assets/image/menu.png"),
        8: require("../../assets/image/grid.png"),
        9: require("../../assets/image/chart-pie.png"),
        10: require("../../assets/image/guzhangtousu.png"),
        11:  require("../../assets/image/shanghu.png"),
        12: require("../../assets/image/baobiao.png"),
        13: require("../../assets/image/erweima.png"),
        14:require("../../assets/image/zhifuzhanghu.png")
      },
      pwdForm: {
        user_id: 0,
        user_pwd: ''
      },

      btnRouterItems:[],
      activName:''
    }
  },
  computed:{
    getCurrentRoutesCount(){
      var arr=[]
      this.$store.state.currentRoutes.forEach(item=>{
            let r={
                name:item.name,
                title:item.meta.title,
                path:item.path
              }
            arr.push(r)
      })
      return arr
    },
    changedRouteName(){
      return this.$store.state.ClickRouteName
    }
  },
  created () {
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth > 980) { this.isCollspase = false } else { this.isCollspase = true }
    this.listMenu = JSON.parse(window.sessionStorage.getItem('MeunItem'))
    this.tokenStr=util.GetToken()
    this.User = util.JesToken()
     if(this.User.logo_name){
       this.imgUrl=util.GetImageUrl(this.User.logo_name)
     }

     this.$store.state.currentRoutes.forEach(item=>{
        let r={
          name:item.name,
          title:item.meta.title,
          path:item.path
        }
        this.btnRouterItems.push(r)
        this.activName=r.name
    })
    
  },
  mounted () {
    this.login_name = this.User.user_name
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
        if (this.screenWidth > 980) { this.isCollspase = false } else { this.isCollspase = true }
      })()
    }
    window.addEventListener('unload',e=>this.unLoad(e))
  },
  components: {
    PwdForm
  },
  methods: {
    unLoad(){
      util.Get('login/loginout')
    },

    tabpanelChaned(tab,event){
      console.log(tab.name)
      this.$router.push("/"+tab.name)
    },
    removeTab(targetName){
     
      if(targetName==='homepage'&&this.$store.state.currentRoutes.length===1){
        return
      }

      let arr= this.$store.state.currentRoutes
      for(let i in arr){
        if(arr[i].name===targetName){
          
          this.$store.state.currentRoutes.splice(i, 1);

          if(this.$store.state.currentRoutes.length===0){
            //如果只有一项，添加主页面
            this.$router.push("/homepage")
          }
          if(targetName===this.activName){
            //如果删除的是当前的页面,跳转到第一个页面
            this.$router.push("/"+this.$store.state.currentRoutes[0].name)
          }
          break;
        }
      }
    },


    toggleCollspace () {
      this.isCollspase = !this.isCollspase
    },
    loginOut (command) {
      if (command === 'a') {
        this.dialogVisible = true
      }
      if (command === 'b') {
        util.Get('login/loginout')
        window.sessionStorage.removeItem('ca_login_token')
        this.$store.state.currentRoutes=[]
        this.$store.state.ClickRouteName=''
        this.activName=''
        this.$router.push('/')
      }
    },
    EditPwd () {
      const flag = this.$refs.childRules.validateForm()
      if (flag) {
        this.pwdForm.user_id=this.User.user_id
        util.Post('user/editpwd', this.pwdForm).then(res => {
          if (res.rpStatus === 10000) {
            this.$message({
              message: '修改密码成功',
              type: 'success'
            })
            this.dialogVisible = false
          }
        })
      }
    },
    Remind () {

    },
    destroyed(){
      window.removeEventListener('unload',e=>this.unLoad(e))
    }
  },
  watch:{
    changedRouteName(newValue,oldValue){
      this.activName=newValue
    }
  }
}
</script>

<style lang="scss" scoped>
.home_container{
  height: 100%;
}

.el-menu-item{
  padding: 0 40px;
}

._pwd_form{
  display: flex;
  flex-direction: column;
  justify-content: start;
}
._pwd_form div{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
}
._pwd_form div>label{
  width: 100px;
}

.dropdown_btn{
  float: right;
}

.logo_img{
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo_img img{
    max-height: 45px;
    width: 60%;
}



.remind{
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
}

.el-header {
    background-color: white;
    color: #333;
    line-height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .el-aside {
    background-color: #fff;
    color: #333;
    text-align: center;
    line-height: 100px;
    height: 100vh;
    overflow-x: hidden;
    .el-menu{
      border-right: none;
    }
  }




  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;

  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }

.el-dropdown{
  float: right;
  margin-right: 30px;
}

.el-dropdown-link {
    cursor: pointer;
}
.el-icon-arrow-down {
    font-size: 12px;
}

::v-deep .el-tabs__header{
  border-bottom:0px solid red
}
::v-deep .el-tabs__header {
  margin:0px
}
::v-deep .el-card__body{
  padding: 0px;
}



/* 
::v-deep .el-dialog__wrapper { 
  .el-dialog {
    .el-dialog__header{
      padding: 10px 20px 10px;
      background-color: #319FE4;
    }
    .el-dialog__headerbtn {
      top: 5px;
      right: 5px;
      padding-top: 10px;
    }
    .el-dialog__title,.el-dialog__headerbtn i{
      color: white;
    }
    .el-dialog__headerbtn .el-dialog__close {
      height: 30px;
      width: 35px;
    }
    .el-tab-pane{
        display:inline
    }
  }
  .el-dialog__body{
    .el-card__header{
      padding: 5px 10px;
      border-bottom:none;
      text-align: left;
    }
  }
} */

</style>
